import script from "./GameLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./GameLoading.vue?vue&type=script&setup=true&lang=js"

import "./GameLoading.vue?vue&type=style&index=0&id=4a8da6ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a8da6ea"]])

export default __exports__